import { render, staticRenderFns } from "./task-datas-audit.vue?vue&type=template&id=c58eec90&scoped=true&"
import script from "./task-datas-audit.vue?vue&type=script&lang=js&"
export * from "./task-datas-audit.vue?vue&type=script&lang=js&"
import style0 from "./task-datas-audit.vue?vue&type=style&index=0&id=c58eec90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58eec90",
  null
  
)

export default component.exports